// =====================================================================
// dailyReportsService (S39) — chamadas axios pra API de relatorios diarios.
//
// Endpoints (todos exigem isAuth + admin/super no backend):
//   GET    /daily-reports?slug=clee&month=2026-05
//   GET    /daily-reports/:id
//   GET    /daily-reports/:id/download
//   POST   /daily-reports/generate { date, force?, slug? }
//   DELETE /daily-reports/:id
// =====================================================================
import api from "./api";

export const listDailyReports = async ({ slug, month } = {}) => {
  const params = {};
  if (slug) params.slug = slug;
  if (month) params.month = month;
  const { data } = await api.get("/daily-reports", { params });
  return data?.reports || [];
};

export const getDailyReport = async (id) => {
  const { data } = await api.get(`/daily-reports/${id}`);
  return data;
};

export const downloadDailyReport = async (id, filename) => {
  // Faz GET e força download via blob
  const response = await api.get(`/daily-reports/${id}/download`, {
    responseType: "blob"
  });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/html" }));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename || `relatorio.html`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const generateDailyReport = async ({ date, force = false, slug } = {}) => {
  const body = { date, force };
  if (slug) body.slug = slug;
  const { data } = await api.post("/daily-reports/generate", body);
  return data;
};

export const deleteDailyReport = async (id) => {
  await api.delete(`/daily-reports/${id}`);
};
